export default __webpack_public_path__ + "static/giant-3-ca72fdf06fe95970e46838d5aa0cc471.jpg";